<h3>Attachments</h3>
<div
  class="flex flex-col md:flex-row md:flex-wrap justify-start md:items-center items-stretch w-full"
>
  <div
    class="flex flex-row flex-wrap justify-start items-center space-x-2 flex-grow-0 border border-green-200 rounded p-1 mb-2"
    *ngFor="let group of attachmentGroups"
  >
    <div class="flex flex-col justify-start items-start">
      <div class="flex flex-row space-x-1">
        <div
          *ngFor="let attachment of group.attachments"
          class="attachment-item flex flex-row justify-start items-center rounded pr-2 pl-1 py-1 text-sm space-x-1"
        >
          <a (click)="downloadAttachment(attachment)">{{
            attachment.file_name
          }}</a>
          <mat-icon
            matTooltip="Delete attachment"
            class="!h-5 !w-5 cursor-pointer"
            (click)="deleteAttachment(attachment.hire_item_id, attachment.id)"
          >
            delete
          </mat-icon>
        </div>
      </div>
      <p class="m-0 text-xs text-gray-700">
        {{ group.stage | hireItemAttachmentStage }} | Uploaded by
        {{ group.user_id | userIdToName | async }} |
        <span [matTooltip]="group.date | amDateFormat : dateFormat">{{
          group.date | amTimeAgo
        }}</span>
        <span *ngIf="group.description"> | {{ group.description }}</span>
      </p>
    </div>
  </div>
</div>
